import React from 'react';
import { Box, Flex } from '../Rebass';
import Meta from '../Meta';
import { AuthorProps } from '.';
import Heading from '../Heading';

const AuthorExtended = ({
  name,
  role,
  image,
  description = null,
  region,
}: AuthorProps) => {
  return (
    <Flex
      flexDirection={['column', 'row', 'row', 'row']}
      alignItems="flex-start"
      mb={[3]}
    >
      {image && (
        <Box
          mr={[0, 4]}
          mb={[4, 0]}
          flex={[null, '1 0 auto']}
          width={['100%', 'unset']}
        >
          {image}
        </Box>
      )}
      <Flex
        flexDirection="column"
        maxWidth="700px"
        width={[1, 7 / 12, 7 / 12, 9 / 12]}
      >
        <Box mb={[2]}>
          <Meta
            meta={[
              { text: role, color: 'textDark' },
              ...(region ? [{ text: region, color: 'brandBrown' }] : []),
            ]}
            size="body"
          />
        </Box>
        <Box mb={[2]}>
          <Heading size="h1" as="h1">
            {name}
          </Heading>
        </Box>
        <Box mb={[3]} width={[1]}>
          {description && description}
        </Box>
      </Flex>
    </Flex>
  );
};

export default AuthorExtended;
